export const mixins = {
  methods: {
    resetQuiz () {
      this.$store.state.userResponses = []
      this.$store.state.results = []
      this.$router.push('/')
    }
  }
}
